import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Form, Row} from "react-bootstrap";
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { validateEmail } from '../utils/uiUtils';


const AppAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [appAttrs, setAppAttrs] = useState({
    name: '',
    description: '',
    vendor: '',
    status: 'PENDING',
    contactName: '',
    contactEmail: '',
    contactPhone: ''
  });


  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setAppAttrs({ ...appAttrs, [e.target.name]: e.target.value })
  }

  const handleGenKeyNSecret = () => {
    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("gen-random-key-secret/128");

        resolve(res.data);

        if (res.status === 200) {
          // Deep copy
          let tmpAttrs = JSON.parse(JSON.stringify(appAttrs));

          tmpAttrs.appKey    = res.data.key;
          tmpAttrs.appSecret = res.data.secret;

          setAppAttrs(tmpAttrs);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

    return;
  }


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!appAttrs.name || appAttrs.name.length === 0) {
      setErrMsg(t("I18N_ERR_Need_App_name"));
    } else if (!appAttrs.vendor || appAttrs.vendor.length === 0) {
      setErrMsg(t("I18N_ERR_Need_App_vendor"));
    } else {
      validateAppName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateAppName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("apps?name=" + appAttrs.name);

        resolve(res.data);

        if ((res.status === 200) && res.data && (res.data.length > 0)) {
          // App name is taken
          setErrMsg(t("I18N_ERR_AppName_taken"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs
    if (!appAttrs.status || appAttrs.status.length === 0) {
      setErrMsg(t("I18N_ERR_Need_App_status"));
    } else if (!appAttrs.contactName || appAttrs.contactName.length === 0) {
      setErrMsg(t("I18N_ERR_Need_Contact_name"));
    } else if (!appAttrs.contactEmail || appAttrs.contactEmail.length === 0) {
      setErrMsg(t("I18N_ERR_Need_Contact_email"));
    } else if (!validateEmail(appAttrs.contactEmail)) {
      setErrMsg(t("I18N_ERR_Bad_Email"));
    } else if (!appAttrs.contactEmail || appAttrs.contactEmail.length === 0) {
      setErrMsg(t("I18N_ERR_Need_Contact_email"));
    } else if (!appAttrs.contactPhone || appAttrs.contactPhone.length === 0) {
      setErrMsg(t("I18N_ERR_Need_Contact_phone"));
    } else {
      setErrMsg('');
      createNewApp();
    }
  }

  const createNewApp = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(appAttrs));

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("apps", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_app")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_App_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <Form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_App_name")}: *</Col>
              <Col>{t("I18N_Vendor")}: *</Col>
              <Col>{t("I18N_Description")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} name="name" value={appAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="vendor" value={appAttrs.vendor}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} name="description" value={appAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Contact_name")}: *</Col>
              <Col>{t("I18N_Contact_email")}: *</Col>
              <Col>{t("I18N_Contact_phone")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} name="contactName" value={appAttrs.contactName}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="contactEmail" value={appAttrs.contactEmail}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="contactPhone" value={appAttrs.contactPhone}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col></Col>
              <Col>{t("I18N_App_key")}:</Col>
              <Col>{t("I18N_App_secret")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleGenKeyNSecret}>
                  {t("I18N_Gen_key_n_secret")}
                </Button>
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                          disabled={true} name="contactEmail" value={appAttrs.appKey}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                          disabled={true} name="contactPhone" value={appAttrs.appSecret}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </Form>
        </Container>

      </Card>
    </>
  );
}

export default AppAdminNewView;
